module.exports = __webpack_public_path__ + "static/img/bcg_k3.e341c25a.png";